import { useEffect } from "react";
import Lenis from '@studio-freight/lenis';
import "@/App.css";

import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Ecosystem } from "./components/Ecosystem";
import { Companies } from "./components/Companies";
import { FashionCulture } from "./components/FashionCulture";
import { Technology } from "./components/Technology";
import { Vision } from "./components/Vision";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#F9F6F0]" data-testid="app-container">
      <Header />
      <main>
        <Hero />
        <About />
        <Ecosystem />
        <Companies />
        <FashionCulture />
        <Technology />
        <Vision />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
